import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const RecommendedProducts = ({ products, onAddToCart }) => {
  const handleAddToCart = (product) => {
    if (onAddToCart) {
      onAddToCart(product);
    }
  };

  return (
    <div className="bg-background">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-heading font-semibold text-foreground">
          You Might Also Like
        </h2>
        <Link 
          to="/product-catalog"
          className="text-sm text-primary hover:text-primary/80 font-medium transition-colors"
        >
          View All Products
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {products?.map((product) => (
          <div key={product?.id} className="bg-card border border-border rounded-lg overflow-hidden shadow-elevation-1 hover:shadow-elevation-2 transition-shadow flex flex-col">
            {/* Product Image */}
            <div className="relative aspect-square bg-muted overflow-hidden">
              <Image
                src={product?.image}
                alt={product?.imageAlt}
                className="w-full h-full object-cover"
              />
              
              {/* Badges */}
              <div className="absolute top-3 left-3 flex flex-col gap-2">
                {product?.isNew && (
                  <span className="bg-primary text-primary-foreground text-xs font-medium px-2 py-1 rounded-md">
                    New
                  </span>
                )}
                {product?.discount > 0 && (
                  <span className="bg-error text-error-foreground text-xs font-medium px-2 py-1 rounded-md">
                    -{product?.discount}%
                  </span>
                )}
              </div>

              {/* Quick Add Button */}
              <div className="absolute top-3 right-3">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => handleAddToCart(product)}
                  className="bg-background/80 backdrop-blur-sm hover:bg-background"
                >
                  <Icon name="ShoppingCart" size={16} />
                </Button>
              </div>
            </div>

            {/* Product Info */}
            <div className="p-4 flex flex-col flex-grow">
              <div className="mb-2">
                <p className="text-xs text-muted-foreground font-medium uppercase tracking-wide">
                  {product?.brand}
                </p>
                <h3 className="text-sm font-medium text-foreground line-clamp-2 leading-tight">
                  {product?.name}
                </h3>
              </div>

              {/* Rating */}
              <div className="flex items-center gap-1 mb-3">
                <div className="flex items-center">
                  {[...Array(5)]?.map((_, i) => (
                    <Icon
                      key={i}
                      name="Star"
                      size={12}
                      className={i < Math.floor(product?.rating) ? 'text-warning fill-current' : 'text-muted-foreground'}
                    />
                  ))}
                </div>
                <span className="text-xs text-muted-foreground">
                  ({product?.reviewCount})
                </span>
              </div>

              {/* Price */}
              <div className="flex items-center justify-between mb-auto">
                <div className="flex items-center gap-2">
                  <span className="text-lg font-semibold text-foreground">
                    ${product?.price?.toFixed(2)}
                  </span>
                  {product?.originalPrice > 0 && (
                    <span className="text-sm text-muted-foreground line-through">
                      ${product?.originalPrice?.toFixed(2)}
                    </span>
                  )}
                </div>
              </div>

              {/* Add to Cart Button - Always at bottom */}
              <Button
                variant="outline"
                size="sm"
                fullWidth
                onClick={() => handleAddToCart(product)}
                iconName="ShoppingCart"
                iconPosition="left"
                className="mt-3"
              >
                Add to Cart
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecommendedProducts;